import React from 'react';
import FaqPanel from '../TorontoFleets/Shared/FaqPanel';

const SubCategoryContainer = ({
  selected,
  cat,
  category,
  FaqGeneral,
  FaqContact,
  FaqEligibility,
  FaqEv,
  FaqPro,
  FaqReferral,
  FaqSignup,
  FaqSafety,
  isSearch,
  input
}) =>
  selected.some(a => a === cat.type) &&
  category === cat.type && (
    <div className="expanded-faq-general-container-normal">
      {cat.type === 'General' && (
        <FaqPanel faq={FaqGeneral} isSearch={isSearch} input={input} />
      )}
      {cat.type === 'Autzu EV' && (
        <FaqPanel faq={FaqEv} isSearch={isSearch} input={input} />
      )}
      {cat.type === 'Eligibility' && (
        <FaqPanel faq={FaqEligibility} isSearch={isSearch} input={input} />
      )}
      {cat.type === 'Signing up' && (
        <FaqPanel faq={FaqSignup} isSearch={isSearch} input={input} />
      )}
      {cat.type === 'Referrals & Rewards' && (
        <FaqPanel faq={FaqReferral} isSearch={isSearch} input={input} />
      )}
      {cat.type === 'Safety & Support' && (
        <FaqPanel faq={FaqSafety} isSearch={isSearch} input={input} />
      )}
      {cat.type === 'Contact Us' && (
        <FaqPanel faq={FaqContact} isSearch={isSearch} input={input} />
      )}
    </div>
  );

export default SubCategoryContainer;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/SubCategoryContainer.js